import { render } from "./ShopForm.vue?vue&type=template&id=ef8816e6"
import script from "./ShopForm.vue?vue&type=script&lang=js"
export * from "./ShopForm.vue?vue&type=script&lang=js"

import exportComponent from "/Users/fanhaipeng/code/giga-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__